export enum ElementTableActionUiEnum {
  INSERT_TOP = 'INSERT_TOP',
  INSERT_LEFT = 'INSERT_LEFT',
  INSERT_RIGHT = 'INSERT_RIGHT',
  INSERT_BOTTOM = 'INSERT_BOTTOM',
  CLEAR = 'CLEAR',
  DELETE = 'DELETE',
  DUPLICATE = 'DUPLICATE',
}
